import * as tslib_1 from "tslib";
import getMailboxCalendarConfigurationOperation from 'owa-service/lib/operation/getMailboxCalendarConfigurationOperation';
export default function getMailboxCalendarConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getMailboxCalendarConfigurationOperation()];
                case 1:
                    response = _a.sent();
                    if (response.ErrorCode) {
                        return [2 /*return*/, null];
                    }
                    else {
                        return [2 /*return*/, response.Options];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=getMailboxCalendarConfiguration.js.map